import React from 'react';
import loadable from '@loadable/component';

const CommuteFilter = loadable(
  () =>
    import(
      /* webpackChunkName: "CommuteFilter.loadable" */ 'app/shared/modules/MobileSRP/Header/FilterModules/CommuteFilter/component'
    ),
);

interface Props {
  showResetButton: boolean;
}

const LoadableCommuteFilter = (props: Props) => {
  return <CommuteFilter {...props} />;
};

export default LoadableCommuteFilter;
